module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAcCAYAAABsxO8nAAAA8klEQVQ4T+1VwRGCMBDcS94MdCAl0IGWohVAB0IHWIGWoh1QAnZAxjeJl4jMOJMA+vLBfUjI3t7lYHYJHL1CKQxyQ0jsfmmQQQeJmiJUZEkIOPqSjcBJRihcsQcnaOReHJjIdOi4k9gHcBWBZjjLQh0zriWtYCyQJA68apdey+EIqelxdss3kYj59Q8xNrISBae3zmj+x1pntM7ov/WI9fgi6Dup1QYp6/X+Q2rnP/Q0YtTsgIvc2V8yd6bQcNebEJ21ozYE4LZvlGBnkxl3Zdw2VHDSIN3dBUpHpF9PX7CfVc6CBssuQkYZvg6UJtQyRvkEQcS/Cq81hvMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/header-mobile.png
// module id = xCIh
// module chunks = 0